import client from '../httpClient';

const schedulesGetGuidancesByCustomerIdApi = (pathParameter, params) => {
  return client.get(`/guidances/customer-list/${pathParameter}`, JSON.stringify(params));
};

export default schedulesGetGuidancesByCustomerIdApi;
